const EXCLUDED_SELECTORS = [
  ".ashley-fab",
  ".floating-home-button",
  ".dashboard-position-indicator",
  ".guide-help-button",
  ".guide-estimates-hub",
  ".guide-command-center",
  ".guide-select-project",
  ".guide-payroll-type",
  ".guide-start-session",
  ".guide-stop-session",
  ".guide-submit-session",
  ".crewpilot-ashley-home-launcher",
  ".crewpilot-ashley-home-logo",
  ".crewpilot-briefing-launcher",
  ".crewpilot-briefing-logo",
  "button",
  "a[href]",
  "input",
  "textarea",
  "select",
  "option",
  "[role='button']",
  "[role='slider']",
  "[role='link']",
  "[contenteditable='true']",
  "label",
];

/**
 * Returns true when long-press should not activate (interactive / Ashley / FHB zones).
 * @param {EventTarget | null} target
 */
export function isLongPressExcludedTarget(target) {
  if (!(target instanceof Element)) {
    return false;
  }

  return EXCLUDED_SELECTORS.some((selector) => target.closest(selector));
}
